
import React from 'react';
import Icon from '../Icon';
import UserChatHeader from './UserChatHeader';
import TextEditor from "../Editor/Editor";
import './Inbox.scss';

const InboxAnnouncementView = ({
    announcement,
    onSetAnnouncement
}) => {
    return (
        <div id="messagesAreaBg" className='announcementPadding'>
            <div className='header_row'>
              <UserChatHeader
                title={(announcement.sendBy?.firstname || "") + ' ' + (announcement.sendBy?.lastname || "")}
                referenceType={""}
                description={announcement.sendBy?.role || ""}
                profileIcon={announcement.sendBy?.profileImage || ""}
                from='Announcement'
                onClickBack={() => onSetAnnouncement({})}
               />
               </div>
            <div className='announcementFullScroll'>
             <div className='announcementHead'><h2>
                 <img src='/assets/annoucement.png'/>
                 {announcement.title}</h2> </div>
             <TextEditor 
                editorState={announcement.description}
                readOnly={true}
            />
            </div>
          </div> 
    )
}

export default InboxAnnouncementView;